module.exports = __webpack_public_path__ + "img/guide_bg.c52dcf0d.png";